import {
  Component,
  EventEmitter,
  Input,
  Output,
  OnInit,
  AfterViewInit,
  ChangeDetectionStrategy,
  ChangeDetectorRef,
  OnChanges,
  SimpleChanges,
  ViewChild
} from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { CdkDragDrop } from '@angular/cdk/drag-drop';
import { TipoEntidadeService } from '@core/services/tipoentidade.service';
import { CargoReferenciaService } from '@core/services/cargoreferencia.service';
import { forkJoin } from 'rxjs';
import { DominiosSharedDataService } from '@modules/dominios/dominios-shared-data.service';
import { NzMessageService } from 'ng-zorro-antd/message';
import { NzButtonType } from 'ng-zorro-antd/button';
import { PaginationComponent } from '@shared/components/pagination/pagination.component';
import { DialogService } from '@core/services/dialog.service';

@Component({
  selector: 'app-lista-niveis-drag-and-drop',
  templateUrl: './lista-niveis-drag-and-drop.component.html',
  styleUrls: ['./lista-niveis-drag-and-drop.component.css'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class ListaNiveisDragAndDropComponent implements OnInit, AfterViewInit, OnChanges {

  // @ViewChild(PaginationComponent)
  // paginator!: PaginationComponent;
  // @Output() pageChange = new EventEmitter<any>();
  // @Output() sortChange = new EventEmitter<any>();

  @Input() dataSet: any[] = [];
  @Output() atualizarDados = new EventEmitter<{ incluirInativos: boolean, dataSet?: any[] }>();
  @Output() salvar = new EventEmitter<any>();
  @Output() editar = new EventEmitter<any>();
  @Output() remover = new EventEmitter<any>();
  @Output() reativar = new EventEmitter<any>();
  @Output() removerSelecionados = new EventEmitter<number[]>();
  @Output() resetHierarquia = new EventEmitter<boolean>();
  @Input() tipoEntidadePadrao: any;
  @Input() subTipoPadrao: any;
  // @Input() especificacaoSubtipoPadrao: any;
  @Input() incluirInativos = false;
  @Input() habilitarBotoesExtras = false;

  @Input() entidade: boolean = false;

  flatNodes: any[] = [];
  selectedIds = new Set<number>();
  selectedId: number | null = null;

  formItem: FormGroup | null = null;
  modoInclusao: 'principal' | 'filho' | null = null;
  itemPai: any = null;
  itemContexto: any = null;
  modoEdicao = false;

  hoveredId: number | null = null;
  isShowingAll = false;
  idCounter = 1000;

  cargoReferenciaList: any[] = [];
  tipoEntidadeList: any[] = [];
  subTipoList: any[] = [];
  especializacaoSubtipoList: any[] = [];

  acoesTabela: {
    icon: string;
    nzType: NzButtonType;
    tooltip: string;
    callback: () => void;
    habilitarBotoesExtras: boolean;
  }[] = [];

  constructor(
    private fb: FormBuilder,
    private tipoEntidadeService: TipoEntidadeService,
    private cargoReferenciaService: CargoReferenciaService,
    private dominiosSharedDataService: DominiosSharedDataService,
    private cd: ChangeDetectorRef,
    private messageService: NzMessageService,
    private dialogService: DialogService,
  ) { }

  ngOnInit(): void {
    this.carregarListas();
    this.atualizarAcoesTabela();
  }

  ngOnChanges(): void {
    this.atualizarFlatNodes();
    this.carregaComboEspecializacao();
  }

  // reset(): void {
  //   this.pageChange.emit(1);
  // }

  ngAfterViewInit(): void {
    this.cd.detectChanges();
    this.dominiosSharedDataService.adicionarDominioPrincipal$
      .subscribe(res => {
        if (res) this.iniciarNovoItem('principal');
      });
    // queueMicrotask(() => {
    //   this.pageChange.emit(this.paginator);
    // });

    // this.paginator.change.subscribe(() => {
    //   this.pageChange.emit(this.paginator);
    // });
  }

  carregarListas(): void {
    forkJoin({
      tiposEntidade: this.tipoEntidadeService.listarPorTipoEnum(),
      cargosReferencia: this.cargoReferenciaService.listar()
    }).subscribe(({ tiposEntidade, cargosReferencia }) => {
      this.tipoEntidadeList = tiposEntidade;
      this.cargoReferenciaList = cargosReferencia;
    });

    this.tipoEntidadeService.listarSubTipos(null).subscribe((subTipos) => {
      this.subTipoList = subTipos;
    });
  }




  atualizarAcoesTabela(): void {
    this.acoesTabela = [
      // {
      //   nzType: 'default',
      //   icon: 'plus',
      //   tooltip: 'Adicionar novo',
      //   callback: () => this.iniciarNovoItem('principal'),
      //   habilitarBotoesExtras: this.habilitarBotoesExtras
      // },
      // {
      //   nzType: 'default',
      //   icon: 'delete',
      //   tooltip: 'Remover selecionados',
      //   callback: () => this.inativarTodosSelecionados(),
      //   habilitarBotoesExtras: this.habilitarBotoesExtras
      // },
      {
        nzType: 'default',
        icon: 'reload',
        tooltip: 'Resetar hierarquia',
        callback: () => this.resetarHierarquia(),
        habilitarBotoesExtras: this.habilitarBotoesExtras
      },
      {
        nzType: 'default',
        icon: this.isShowingAll ? 'node-collapse' : 'node-expand',
        tooltip: this.isShowingAll ? 'Ocultar todos' : 'Mostrar todos',
        callback: () => {
          this.isShowingAll ? this.ocultarTodos() : this.mostrarTodos();
          this.atualizarAcoesTabela();
        },
        habilitarBotoesExtras: true
      }
    ];
  }

  carregaComboEspecializacao() {
    const orgao = 9;
    if (this.tipoEntidadePadrao?.value == orgao && this.subTipoPadrao?.value) {
      if (this.subTipoPadrao) {
        this.tipoEntidadeService.listarEspecificacoesPorSubTipo(this.subTipoPadrao.value).subscribe((res: any) => {
          this.especializacaoSubtipoList = res;
        });
      }
    }
  }

  iniciarNovoItem(modo: 'principal' | 'filho', pai?: any): void {
    const tipoEntidadePadrao = this.tipoEntidadePadrao?.value ?? null;
    const subTipoPadrao = this.subTipoPadrao?.value ?? null;
    // const especificacaoSubtipoPadrao = this.especificacaoSubtipoPadrao?.value ?? null;

    if (tipoEntidadePadrao) {
      this.modoEdicao = false;
      this.modoInclusao = modo;
      this.itemPai = pai ?? null;

      this.formItem = this.fb.group({
        cargoReferencia: [null, Validators.required],
        tipoEntidade: [{ id: tipoEntidadePadrao }, Validators.required],
        subTipo: [{ id: subTipoPadrao }],
        // especificacaoSubTipoEntidadeId: [{ id: especificacaoSubtipoPadrao }],
        parentId: pai ? pai.id : null
      });
      console.log('Criando formulário para novo item', this.formItem.value);
      this.formItem.get('tipoEntidade')?.disable();
      this.formItem.get('subTipo')?.disable();
      // this.formItem.get('especificacaoSubTipoEntidadeId')?.disable();

      console.log('Iniciando novo item', this.formItem.value);
      this.cd.detectChanges();
    } else {
      this.messageService.error('Selecione um tipo de entidade padrão antes de adicionar um novo item.');
    }
  }

  iniciarNovoItemFilho(): void {
    const pai = this.selectedId ? this.buscarNode(this.selectedId) : null;
    if (pai) {
      this.iniciarNovoItem('filho', pai);
    } else {
      this.messageService.error('Selecione um item principal!');
    }
  }

  editarItem(item: any): void {
    if (!item) return;
    this.selectedId = item.id;
    this.modoEdicao = true;
    this.modoInclusao = item.parentId ? 'filho' : 'principal';
    this.itemPai = item.parentId ? this.buscarNode(item.parentId) : null;
    this.itemContexto = item;
    this.formItem = this.criarFormulario(item);
  }

  confirmarNovoItem(): void {
    console.log('confirmarNovoItem', this.modoEdicao);


    if (!this.formItem?.valid) return;
    const values = this.formItem.value;

    if (this.modoEdicao && this.itemContexto) {
      const node = this.buscarNode(this.itemContexto.id);
      if (!node) return;

      Object.assign(node, values);

      node.idCargoReferencia = values.cargoReferencia?.id ?? null;
      node.nomeCargoReferencia = values.cargoReferencia?.nomeCargoReferencia ?? node?.nomeCargoReferencia;

      node.tipoEntidadeId = values.tipoEntidade?.id ?? node?.tipoEntidadeId;
      node.nomeTipoEntidade = values.tipoEntidade?.nomeTipoEntidade ?? node?.nomeTipoEntidade;

      node.idSubTipoEntidade = values.subTipo?.id ?? node?.idSubTipoEntidade;
      node.nomeSubTipoEntidade = values.subTipo?.nomeSubTipoEntidade ?? node?.nomeSubTipoEntidade;

      // node.especificacaoSubTipoEntidadeId = values.especificacaoSubTipoEntidadeId?.id ?? node?.especificacaoSubTipoEntidadeId;
      // node.nomeEspecificacaoSubTipoEntidade = values.especificacaoSubTipoEntidadeId?.nome ?? node?.nomeEspecificacaoSubTipoEntidade;

      delete node.cargoReferencia;
      delete node.tipoEntidade;
      delete node.subTipo;
      // delete node.especificacaoSubTipoEntidadeId;

      this.editar.emit(this.dataSet);
      // this.editar.emit({ node, values });
    } else {
      const tipoEntidadePadrao = this.tipoEntidadePadrao?.value ?? null;
      const tipoEntidadeInserir = this.tipoEntidadeList.find(item => item.id === tipoEntidadePadrao);
      const subTipoPadrao = this.subTipoPadrao?.value ?? null;
      const subTipoInserir = this.subTipoList.find(item => item.id === subTipoPadrao);
      // const especificacaoSubTipoPadrao = this.especificacaoSubtipoPadrao?.value ?? null;
      // const especificacaoSubTipoInserir = this.especializacaoSubtipoList.find(item => item.id === especificacaoSubTipoPadrao);

      const novo: any = {
        parentId: null,
        expanded: true,
        children: [],
        ordemExibicao: 0,
        idCargoReferencia: values.cargoReferencia?.id,
        nomeCargoReferencia: values.cargoReferencia?.nomeCargoReferencia ?? null,
        tipoEntidadeId: values.tipoEntidade?.id ?? tipoEntidadeInserir?.id,
        nomeTipoEntidade: values.tipoEntidade?.nomeTipoEntidade ?? tipoEntidadeInserir?.nomeTipoEntidade,
        idSubTipoEntidade: values.subTipo?.id ?? subTipoInserir?.id,
        nomeSubTipoEntidade: values.subTipo?.nomeSubTipoEntidade ?? subTipoInserir?.nomeSubTipoEntidade,
        // nomeEspecificacaoSubTipoEntidade: values.especificacaoSubTipoEntidadeId?.nome ?? especificacaoSubTipoInserir?.nome,
        // especificacaoSubTipoEntidadeId: values.especificacaoSubTipoEntidadeId?.id ?? especificacaoSubTipoInserir?.id
      };

      if (this.modoInclusao === 'filho' && this.itemPai) {
        this.itemPai.children = this.itemPai.children || [];
        novo.parentId = this.itemPai.id;
        novo.ordemExibicao = this.itemPai.children.length;
        this.itemPai.children.push(novo);
        this.itemPai.expanded = true;
      } else {
        novo.ordemExibicao = this.dataSet.length;
        this.dataSet.push(novo);
      }
      this.salvar.emit(this.dataSet);
    }

    this.cancelarNovoItem();
    // this.atualizarOrdemGeral();
    this.reordenarSemAtualizarDados();
  }

  cancelarNovoItem(): void {
    this.formItem = null;
    this.modoInclusao = null;
    this.itemPai = null;
    this.modoEdicao = false;
    this.selectedId = null;
    this.itemContexto = null;
  }

  limparForm(): void {
    this.formItem?.reset();
    const tipoEntidadePadrao = this.tipoEntidadePadrao?.value ?? null;
    this.formItem?.get('tipoEntidade')?.setValue(tipoEntidadePadrao ?? null);
  }

  selectRow(id: number): void {
    this.selectedId = this.selectedId === id ? null : id;
  }

  toggleExpand(node: any): void {
    node.expanded = !node.expanded;
    this.atualizarFlatNodes();
  }

  atualizarFlatNodes(): void {
    this.flatNodes = [];

    // Validar se dataSet é um array válido antes de processar
    if (Array.isArray(this.dataSet) && this.dataSet.length > 0) {
      this.flatten(this.dataSet, 0);
    }

    this.formItem = null;
    this.modoEdicao = false;
    this.modoInclusao = null;
    this.cd.detectChanges();
  }

  flatten(lista: any[], nivel: number): void {
    // Validar se lista é array antes de processar
    if (!Array.isArray(lista) || lista.length === 0) {
      return;
    }

    lista.sort((a, b) => a.ordemExibicao - b.ordemExibicao).forEach(item => {
      this.flatNodes.push({ ...item, nivel: nivel, nodeRef: item });
      if (item.expanded && item.children?.length) {
        this.flatten(item.children, nivel + 1);
      }
    });
  }

  moverAcima(item: any): void {
    const lista = this.parentArray(item.parentId);
    const idx = lista.findIndex(n => n.id === item.id);
    if (idx > 0) {
      [lista[idx - 1], lista[idx]] = [lista[idx], lista[idx - 1]];
      this.atualizarOrdemGeral();
    }
  }

  moverAbaixo(item: any): void {
    const lista = this.parentArray(item.parentId);
    const idx = lista.findIndex(n => n.id === item.id);
    if (idx < lista.length - 1) {
      [lista[idx + 1], lista[idx]] = [lista[idx], lista[idx + 1]];
      this.atualizarOrdemGeral();
    }
  }
  alternarAtivacao(item: any): void {
    if (!item) return;

    const estaInativo = !!item.dataInativo;

    if (estaInativo) {
      this.reativar.emit(item);
    } else {
      this.remover.emit(item);
    }
  }

  inativarTodosSelecionados(): void {
    const ids = Array.from(this.selectedIds);
    if (!ids.length) {
      this.messageService.error('Selecione ao menos um item para remover.');
      return;
    }

    this.dialogService.confirm(`Você tem certeza que deseja remover todos os itens selecionados?`, () => {
      this.removerSelecionados.emit(ids);
    });
    // this.atualizarOrdemGeral();
  }

  resetarHierarquia(): void {
    this.dialogService.confirm(`Você tem certeza que deseja remover todos os itens e começar de novo?`, () => {
      this.resetHierarquia.emit(true);
    });
    // this.atualizarOrdemGeral();
  }

  onDrop(event: CdkDragDrop<any[]>): void {
    const dragged = event.item.data;
    const target = this.flatNodes[event.currentIndex];
    if (!dragged) return;

    const draggedIsFirstLevel = dragged.nodeRef.parentId == null;
    const targetIsFirstLevel = target && target.nodeRef.parentId == null;
    const isSelf = dragged.nodeRef.id === target?.nodeRef.id;
    const isMovendoParaDentroDeFilho = target && this.isDescendantOrSame(dragged.nodeRef, target.nodeRef);

    if (isSelf) {
      return;
    }
    if (isMovendoParaDentroDeFilho) {
      return;
    }

    const { node: removed } = this.removerNoInPlace(this.dataSet, dragged.id);
    if (!removed) return;

    const usarSelecionado = this.selectedIds.size > 0;
    const vaiAntes = event.currentIndex < event.previousIndex;
    let inserido = false;

    if (target) {
      const targetNode = target.nodeRef;
      const selecionado = this.selectedIds.has(targetNode.id);
      const targetList = this.parentArray(targetNode.parentId);
      const pos = targetList.findIndex(n => n.id === targetNode.id);

      if (usarSelecionado && selecionado) {
        targetNode.children = targetNode.children || [];
        targetNode.children.push(removed);
        removed.parentId = targetNode.id;
        inserido = true;
      } else {
        targetList.splice(vaiAntes ? pos : pos + 1, 0, removed);
        removed.parentId = targetNode.parentId;
        inserido = true;
      }
    }

    if (!inserido) {
      this.dataSet.push(removed);
      removed.parentId = null;
    }

    this.atualizarOrdemGeral();
  }

  isDescendantOrSame(parent: any, possibleChild: any): boolean {
    if (!parent || !possibleChild) return false;
    if (parent.id === possibleChild.id) return true;
    if (!parent.children) return false;

    return parent.children.some((child: any) => this.isDescendantOrSame(child, possibleChild));
  }

  toggleSelectAll(event: Event): void {
    const checked = (event.target as HTMLInputElement).checked;
    this.selectedIds.clear();
    if (checked) this.marcarTodos(this.dataSet);
  }

  onCheck(id: number, event: Event): void {
    const checked = (event.target as HTMLInputElement).checked;
    if (checked) {
      this.selectedIds.add(id);
    } else {
      this.selectedIds.delete(id);
    }
  }

  mostrarTodos(): void {
    this.isShowingAll = true;
    this.expandirTodos(this.dataSet);
    this.atualizarFlatNodes();
  }

  ocultarTodos(): void {
    this.isShowingAll = false;
    this.recolherTodos(this.dataSet);
    this.atualizarFlatNodes();
  }

  private criarFormulario(item: any = null): FormGroup {
    const form = this.fb.group({
      cargoReferencia: [{ id: item?.idCargoReferencia || null }, Validators.required],
      tipoEntidade: [{ id: item?.tipoEntidadeId || null }, Validators.required],
      subTipo: [{ id: item?.idSubTipoEntidade || null }, Validators.required],
      // especificacaoSubTipoEntidadeId: [{ id: item?.especificacaoSubTipoEntidadeId || null }]
    });
    console.log('Criando formulário para item', item, form.value);

    if (item) {
      form.get('tipoEntidade')?.disable();
      form.get('subTipo')?.disable();
      // form.get('especificacaoSubTipoEntidadeId')?.disable();
    }
    return form;
  }

  private buscarNode(id: number): any | null {
    return this.buscarNoPorId(this.dataSet, id);
  }

  private buscarNoPorId(lista: any[], id: number): any | null {
    for (const item of lista) {
      if (item.id === id) return item;
      if (item.children) {
        const result = this.buscarNoPorId(item.children, id);
        if (result) return result;
      }
    }
    return null;
  }

  private parentArray(parentId: number | null): any[] {
    if (parentId === null) return this.dataSet;
    let found: any[] = [];
    const buscar = (lista: any[]) => {
      for (const item of lista) {
        if (item.id === parentId) found = item.children || [];
        else if (item.children) buscar(item.children);
      }
    };
    buscar(this.dataSet);
    return found;
  }

  private removerNoInPlace(lista: any[], id: number): { node: any | null } {
    let node = null;
    const buscar = (listaInterna: any[]): boolean => {
      for (let i = 0; i < listaInterna.length; i++) {
        if (listaInterna[i].id === id) {
          node = listaInterna.splice(i, 1)[0];
          return true;
        }
        if (listaInterna[i].children && buscar(listaInterna[i].children)) return true;
      }
      return false;
    };
    buscar(lista);
    return { node };
  }

  private atualizarOrdemGeral(): void {
    this.reordenar(this.dataSet, null);
    this.atualizarFlatNodes();
    this.atualizarDados.emit({
      incluirInativos: this.incluirInativos,
      dataSet: this.dataSet
    });
  }

  private reordenarSemAtualizarDados() {
    this.reordenar(this.dataSet, null);
    this.atualizarFlatNodes();
  }

  private reordenar(lista: any[], parentId: number | null): void {
    lista.forEach((n, i) => {
      n.ordemExibicao = i;
      n.parentId = parentId;
      if (n.children?.length) this.reordenar(n.children, n.id);
    });
  }

  private marcarTodos(lista: any[]): void {
    lista.forEach(item => {
      this.selectedIds.add(item.id);
      if (item.children) this.marcarTodos(item.children);
    });
  }

  private selectWithChildren(id: number, visited = new Set<number>()): void {
    if (visited.has(id)) return;
    visited.add(id);
    const node = this.buscarNode(id);
    if (!node) return;
    this.selectedIds.add(id);
    node.children?.forEach((c: any) => this.selectWithChildren(c.id, visited));
  }

  private unselectWithChildren(id: number, visited = new Set<number>()): void {
    if (visited.has(id)) return;
    visited.add(id);
    const node = this.buscarNode(id);
    if (!node) return;
    this.selectedIds.delete(id);
    node.children?.forEach((c: any) => this.unselectWithChildren(c.id, visited));
  }

  private expandirTodos(lista: any[]): void {
    lista.forEach(n => {
      n.expanded = true;
      if (n.children) this.expandirTodos(n.children);
    });
  }

  private recolherTodos(lista: any[]): void {
    lista.forEach(n => {
      n.expanded = false;
      if (n.children) this.recolherTodos(n.children);
    });
  }

  podeMoverAcima(item: any): boolean {
    const lista = this.parentArray(item.parentId);
    return lista.findIndex(n => n.id === item.id) > 0;
  }

  podeMoverAbaixo(item: any): boolean {
    const lista = this.parentArray(item.parentId);
    const idx = lista.findIndex(n => n.id === item.id);
    return idx < lista.length - 1;
  }

  setContextItem(item: any, event: MouseEvent): void {
    event.stopPropagation();
    setTimeout(() => (this.itemContexto = item), 0);
  }

  iconeExpandido(item: any): string {
    return item?.nodeRef?.expanded ? 'down' : 'right';
  }

  tooltipExpandido(item: any): string {
    return item?.nodeRef?.expanded ? 'Recolher Item' : 'Expandir Item';
  }

  trackById(index: number, item: any): number {
    return item.id;
  }

  sort(event: any): void {
    // this.sortChange.emit(event);
  }

  compareFn = (o1: any, o2: any): boolean => {
    if (!o1 || !o2) return o1 === o2;

    const getId = (obj: any) =>
      obj?.id ?? obj?.codigo ?? obj?.uuid ?? JSON.stringify(obj);

    return getId(o1) === getId(o2);
  };

  get cargoDisponivel(): any[] {
    const usados = this.getCargosUsados(this.dataSet);
    if (this.modoEdicao && this.itemContexto?.idCargoReferencia) {
      const idx = usados.indexOf(this.itemContexto.idCargoReferencia);
      if (idx > -1) usados.splice(idx, 1);
    }
    return this.cargoReferenciaList.filter(c => !usados.includes(c.id));
  }

  private getCargosUsados(lista: any[]): number[] {
    let usados: number[] = [];
    for (const item of lista) {
      if (item.idCargoReferencia) usados.push(item.idCargoReferencia);
      if (item.children?.length) usados = usados.concat(this.getCargosUsados(item.children));
    }
    return usados;
  }

  tipoOrgao(): boolean {
    return this.tipoEntidadePadrao?.value == 9;
  }

  get tipoEntidadeControl(): any {
    return this.formItem?.get('tipoEntidade');
  }

  get subTipoControl(): any {
    return this.formItem?.get('subTipo');
  }

  // get especificacaoControl(): any {
  //   return this.formItem?.get('idEspecificacao');
  // }

  get tipoEntidadeOrgao() {
    const orgao = 9;
    return this.tipoEntidadeControl?.value === orgao;
  }
}
